import  { useContext } from "react";
import { FunctionContext } from "../../../context/FunctionProvider";
import company_img from "../../../assets/svg/Group 18.svg";
import location_icon from "../../../assets/svg/tdesign_location (1).svg";
import calander_icon from "../../../assets/svg/oui_token-date.svg";
import shedule_icon from "../../../assets/svg/mingcute_time-line.svg";
import dayjs from "dayjs";
import { Details } from "@mui/icons-material";
import { path } from "../../../constant";
const Bandage = ({ customStyleName, lable }) => {
  return (
    <div className={`bandage flex center ${customStyleName}`}>{lable}</div>
  );
};
const IconWithText = ({ image = "", value }) => {
  return (
    <div className="flex ai width-auto gap-4">
      <div className="iconb flex center ">
        <img alt="" className="b-0" src={image}></img>
      </div>
      <p className="m-0 info-text">{value}</p>
    </div>
  );
};
function WalkinsCard({
  detials,
  landingage = " o ",
  flag = true,
  similar_flag = true,
  customClassName,
  but_lable="I’m interested"
}) {
  const { navigate ,findElement } =
    useContext(FunctionContext);
  const viewDetials = (id) => {
    navigate(path.wakinDetialsPage(id));
  };
  const DateFormatter = (date) => {
    // Parse and format the date using dayjs
    return dayjs(date).format("DD MMM YYYY"); // Outputs: December 28, 2024
  };

  const truncateText = (text, limit) => {
    if (text) {
      if (text.length > limit) {
        return text.slice(0, limit) + "...";
      }
      return text; // Return original text if it's shorter than the limit
    } else {
      return "";
    }
  };
  const calculateDaysAgo = (dateString) => {
    // Parse the input date string as a Date object
    const postedDate = new Date(dateString);

    // Get the current date and time
    const currentDate = new Date();

    // Calculate the difference in milliseconds
    const timeDifference = currentDate - postedDate;

    // Convert milliseconds to days and round to the nearest whole number
    const daysAgo = Math.round(timeDifference / (1000 * 60 * 60 * 24));

    return daysAgo;
  };
  return (
    <div
      className={`flex  D-card   ${landingage} coloum`}
      onClick={() => viewDetials(detials.id)}
    >
      <div className={"first-card-element   flex gap-58 ai " + landingage}>
        <div className="flex s gap-21  hidden">
          <div className="img-bg flex center mob-size">
            <img alt=""
              className="img-bg"
              src={detials?.employer_logo ? detials.employer_logo : company_img}
            ></img>
          </div>
          <div className="flex ai  coloum h-100 e marquee">
            <p direction="slide" className="m-0 role">
              {detials?.walkInTitle ? detials.walkInTitle : "Java Developer"}
            </p>
            <p className="m-0 company">
              {detials?.companyName ? detials.companyName : "ABCD company"}
            </p>
          </div>
        </div>
        <div className={"card-13  flex   width-100 " + landingage}>
          {similar_flag && (
            <div className="flex ai gap-10 ">
              <Bandage
                customStyleName={"green-color"}
                lable={detials?.employmentType}
              ></Bandage>
            </div>
          )}

          {/* <img alt="" src={save_icon}></img> */}
        </div>
      </div>
      {flag && (
        <div
          className={
            "second-card-element  flex w gap-33 " + landingage + customClassName
          }
        >
          <IconWithText
            image={location_icon}
            value={truncateText(
              detials?.walkInLocation ? detials.walkInLocation : "No Data",
              12
            )}
          ></IconWithText>
          {/* <IconWithText
            image={coin_icon}
            value={"$15,000 - $25,000"}
          ></IconWithText> */}
          <IconWithText
            image={calander_icon}
            value={
              detials?.interviewDate
                ? DateFormatter(detials.interviewDate)
                : "No Data"
            }
          ></IconWithText>
          <IconWithText
            image={shedule_icon}
            value={`${detials?.interviewTimeFrom}- ${detials?.interviewTimeTo}`}
          ></IconWithText>
        </div>
      )}
      {similar_flag && <hr className={"line  m-0 " + landingage}></hr>}
      {similar_flag && (
        <div className={" flex  third-card-element  " + landingage}>
          <p className={"post " + landingage}>
            {Details?.job_posted_at_datetime_utc
              ? `Posted on ${calculateDaysAgo(
                  detials.job_posted_at_datetime_utc
                )} days ago `
              :'Posted on '+ (detials?.job_posted_at?detials?.job_posted_at:"few days ago")}
          </p>
          <div className="flex s gap-4">
            {/* <button className="modern-button searchbutton ouline-b ">
              <p className="m-0 p">View map</p>
            </button> */}
            <button className="modern-button searchbutton" style={{pointerEvents:"all"}} onClick={() => {
                
                but_lable==="I’m interested"? viewDetials(detials.id):window.open(detials.mapLocationLink,'_blank')
                
                }}>
              <p className="m-0 " >
                {but_lable}
              </p>
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
export default WalkinsCard;
